import { authSDK } from 'Utils/AuthSDK';
import { profileSDK } from 'Utils/ProfileSDK';
import { getUser } from 'Utils/UserCookie';
import { logger } from 'Utils/Logger';

//API calls from Auth SDK which are generally for MVPD

export const getAuthentication = async (options = {}) => {
  logger.apiRequest('get mvpd authentication');
  try {
    const result = await authSDK().getAdobeRegCode(options);
    logger.apiResponse('get mvpd authentication success', result);
    return result;
  } catch (error) {
    logger.apiError('get mvpd authentication error', error);
    console.error(error);
  }
};

export const checkAuthenticationRequest = async (options = {}) => {
  const { deviceId, deviceType, requestor } = options;
  const user = getUser() || {};
  const { refreshToken } = user;
  logger.apiRequest('check mvpd authentication');
  try {
    let result;
    if (refreshToken) {
      result = await authSDK().checkAdobeAuthNRefresh({ refreshToken, deviceId, deviceType, requestor });
      logger.apiResponse('check mvpd authentication success', result);
    } else {
      const anonymousUser = await profileSDK().loginAnonymously({ deviceId });
      const anonymousRefreshToken = anonymousUser?.refreshToken;

      if (anonymousUser?.accessToken) {
        authSDK().setAccessToken({ accessToken: anonymousUser.accessToken });
      }

      if (!anonymousRefreshToken) {
        throw new Error('Failed anonymous authentication');
      }
      result = await authSDK().checkAdobeAuthNRefresh({
        deviceId,
        refreshToken: anonymousRefreshToken,
        deviceType,
        requestor,
      });
      logger.apiResponse('check mvpd authentication success', result);
    }
    return result;
  } catch (e) {
    logger.apiError('check mvpd authentication error', e);
    throw e;
  }
};

export const getMvpdEntitlements = async () => {
  logger.apiRequest('get mvpd entitlements');
  try {
    const result = await authSDK().getEntitlements();
    const entitlements = result?.entitlements;
    const entitlementsArray = entitlements && Object.keys(entitlements);
    logger.apiResponse('get mvpd entitlements success', entitlementsArray);
    return entitlementsArray;
  } catch (error) {
    logger.apiError('get mvpd entitlements error', error);
    console.error(error);
  }
};

export const getUserMetadata = async () => {
  logger.apiRequest('get mvpd user metadata');
  try {
    const result = await authSDK().getUserMetadata();
    logger.apiResponse('get mvpd user metadata success', result);
    return result;
  } catch (error) {
    logger.apiError('get mvpd user metadata error', error);
    console.error(error);
  }
};

export const logoutOfMVPD = async () => {
  logger.apiRequest('logout mvpd');
  try {
    const { refreshToken } = getUser();
    const result = await authSDK().logoutOfMVPD({ refreshToken });
    logger.apiResponse('logout mvpd success', result);
    return result;
  } catch (error) {
    logger.apiError('logout mvpd error', error);
    console.error(error);
  }
};
